import React from 'react';
import { Modal, CloseButton, Button, Carousel } from 'react-bootstrap';

const MerchandiseModal = ({ showModal, handleCloseModal, selectedItem }) => {
  console.log(selectedItem)
  return (
    <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
      <Modal.Header>
        <CloseButton onClick={handleCloseModal} />
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: '#f8f9fa' }}>
        <div className="d-flex justify-content-center">
          {selectedItem && (
            <div>
              {selectedItem.picture.length > 1 ? (
                <Carousel data-bs-theme="dark" interval={null} style={{ height: '400px' }}>
                  {selectedItem.picture.map((pic, index) => (
                    <Carousel.Item key={index}>
                      <img
                        src={pic.url}
                        alt={`${index + 1}`}
                        style={{ marginBottom: '10px', maxWidth: '100%', maxHeight: '350px' }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              ) : (
                <img
                  src={selectedItem.picture[0].url}
                  alt={selectedItem.name}
                  style={{ marginBottom: '10px', maxWidth: '100%', maxHeight: '350px' }}
                />
              )}
              <div className="text-center">
                <h5>{selectedItem.name}</h5>
                {selectedItem.company_name && (
                  <p>
                    <em>{selectedItem.company_name}</em>
                  </p>
                )}
                <p>
                  <strong>Price:</strong> ${selectedItem.price}
                </p>
                {selectedItem.link && (
                  <Button variant="dark" href={selectedItem.link} target="_blank" rel="noopener noreferrer">
                    Shop on {selectedItem.company_name}
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MerchandiseModal;
